import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M17 18h1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 18h1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 18h1", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Factory";
const Factory = memo(themed(Icon));
export {
  Factory
};
//# sourceMappingURL=factory.js.map
